import { Button, Panel, PanelFooter, PanelMain, PanelMainBody } from '@patternfly/react-core'
import { useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import { Era5API, Era5DownloadJob } from '../../../client'
import EntityTable from '../../../components/EntityTable'
import useMobile from '../../../hooks/useMobile'
import calcVerticalHeight from '../../../utils/calcVerticalHeight'
import { getFirstSegment } from '../../../utils/getFirstSegment'
import Page from '../../shared/Page'
import { ERA5_DOWNLOAD_QUERYKEY } from '../constants'
import ModalRegistrarDownload from './ModalRegistrarEvento'

const Era5Download = () => {
  const [isNavOpen, setNavOpen] = useState(window.innerHeight < window.innerWidth)
  const isMobile = useMobile()

  const { data = [], isLoading } = useQuery<Era5DownloadJob[]>({
    queryKey: [ERA5_DOWNLOAD_QUERYKEY],
    queryFn: Era5API.getAllDownloadJobs,
  })

  const [isModalOpen, setModalOpen] = useState(false)

  return (
    <Page pageName='ERA5 Download' isNavOpen={isNavOpen} setNavOpen={setNavOpen}>
      <Panel className='pf-v5-u-box-shadow-sm'>
        <PanelMain>
          <PanelMainBody>
            <EntityTable<Era5DownloadJob>
              items={data}
              itemKeyName='id'
              isLoading={isLoading}
              isCompact
              style={{
                height: calcVerticalHeight({
                  gridSize: 1,
                  elementSize: 1,
                  customOffset: '7rem',
                }),
                minHeight: '12rem',
              }}
              columnConfig={[
                { key: 'id', description: 'Id', formatter: v => getFirstSegment(v) },
                { key: 'label', description: 'Label' },
                { key: 'area', description: 'Área' },
                {
                  key: 'ts_in',
                  description: 'Período de Download',
                  formatter: (_, i) => {
                    return `${new Date(i.ts_in).toLocaleDateString('pt-BR', {
                      month: '2-digit',
                      year: 'numeric',
                    })} - ${new Date(i.ts_fin).toLocaleDateString('pt-BR', {
                      month: '2-digit',
                      year: 'numeric',
                    })}`
                  },
                },
                {
                  key: 'triggered_ts',
                  description: 'Inicio do Download',
                  formatter: v => {
                    return v
                      ? new Date(v).toLocaleDateString('pt-BR', {
                          month: '2-digit',
                          year: 'numeric',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit',
                        })
                      : '--'
                  },
                },
                {
                  key: 'last_modified',
                  description: 'Fim do Download',
                  formatter: (v, instance) => {
                    if (instance.progress !== 100) return '--'
                    return v
                      ? new Date(v).toLocaleDateString('pt-BR', {
                          month: '2-digit',
                          year: 'numeric',
                          day: '2-digit',
                          hour: '2-digit',
                          minute: '2-digit',
                          second: '2-digit',
                        })
                      : '--'
                  },
                },
                {
                  key: 'progress',
                  description: 'Progresso',
                  formatter: v => `${v}%`,
                },
                {
                  key: 'status',
                  description: 'Status',
                  formatter: v => {
                    if (v === null) return 'Em fila'
                    return v
                  },
                },
                {
                  key: 'username',
                  description: 'Usuário',
                },
              ]}
            />
          </PanelMainBody>
          <PanelFooter>
            <Button
              onClick={() => setModalOpen(true)}
              style={{
                height: '36px',
                margin: 0,
                ...(isMobile && { width: '100%' }),
              }}
            >
              Adicionar
            </Button>
          </PanelFooter>
        </PanelMain>
      </Panel>
      {isModalOpen && (
        <ModalRegistrarDownload isOpen={isModalOpen} onClose={() => setModalOpen(false)} />
      )}
    </Page>
  )
}

export default Era5Download
